const OnSiteErrorTypes = {
  InsufficientCapacity: "InsufficientCapacity",
  InvalidEntityState: "InvalidEntityState",
  MeetingAttendeeUnavailable: "MeetingAttendeeUnavailable",
};

export default OnSiteErrorTypes;
